export default "__VITE_ASSET__D9Vs7lt7__"